export default {
    loan: 'VEHICLE_LOAN',
    loanCommitment: 'LOAN_COMMITMENT',
    vehicleLoan: 'VEHICLE_LOAN',
    creditCard: 'CREDIT_CARD',
    creditLoan: 'CREDIT_LOAN',
    other: 'OTHER',
};
